import React from "react";
import { User } from "react-feather";

/**
 * Employee enrolment photo, initials fallback - the same treatment Guard Lookup
 * and the Attendance Dashboard already use.
 *
 * The photo bytes are fetched once per employee by the page-level
 * useEmployeePhotoCache hook and handed down here as an object URL; this
 * component never fetches, so an employee repeated across twenty rows still
 * costs one request. A guid maps to undefined (in flight), null (no photo) or
 * the URL, so anything that isn't a string renders initials.
 */
const initialsOf = (name) =>
  (name || "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();

const EmployeeAvatar = ({ name, photoUrl, size }) => {
  const cls = `onestop-avatar${size === "lg" ? " lg" : ""}`;
  if (typeof photoUrl === "string" && photoUrl) {
    return (
      <span className={cls} title={name || ""}>
        <img src={photoUrl} alt="" />
      </span>
    );
  }
  const initials = initialsOf(name);
  return (
    <span className={cls} title={name || "No enrolment photo"}>
      {initials || <User size={size === "lg" ? 20 : 14} />}
    </span>
  );
};

export default EmployeeAvatar;
